import React, { useState, useEffect } from 'react';

const Footer: React.FC = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isDesktop = windowWidth >= 768;

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <footer className="portal-footer" style={{
      backgroundColor: '#2c3e50',
      borderTop: '1px solid #34495e',
      padding: '30px 0 20px'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 20px'
      }}>
        <div style={{
          display: 'flex',
          flexWrap: isDesktop ? 'nowrap' : 'wrap',
          gap: isDesktop ? '40px' : '20px',
          justifyContent: 'center',
          alignItems: 'flex-start'
        }}>
          <div style={{
            flex: isDesktop ? '0 0 auto' : '0 0 100%',
            maxWidth: isDesktop ? '25%' : '100%',
            textAlign: isDesktop ? 'left' : 'center'
          }}>
            <h6 style={{ fontWeight: '600', marginBottom: '10px', fontSize: '14px', color: '#ecf0f1' }}>PureHD</h6>
            <p style={{ fontSize: '12px', color: '#95a5a6', marginBottom: '8px', lineHeight: '1.5' }}>
              Experience the future of television with PureHD's cutting-edge solutions.
            </p>
            <a href="https://www.purehd.com" target="_blank" rel="noopener noreferrer"
               style={{ color: '#bdc3c7', textDecoration: 'none', fontSize: '12px' }}>
              PureHD.com
            </a>
          </div>

          <div style={{
            flex: isDesktop ? '0 0 auto' : '0 0 100%',
            maxWidth: isDesktop ? '20%' : '100%',
            textAlign: isDesktop ? 'left' : 'center'
          }}>
            <h6 style={{ fontWeight: '600', marginBottom: '10px', fontSize: '14px', color: '#ecf0f1' }}>Support</h6>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '5px' }}>
                <a href="https://www.purehd.com/contact/" target="_blank" rel="noopener noreferrer"
                   style={{ color: '#bdc3c7', textDecoration: 'none', fontSize: '12px' }}>Contact Us</a>
              </li>
              {/* Help Center link - hidden until help center is updated
              <li style={{ marginBottom: '5px' }}>
                <a href="https://www.purehd.com/support/" target="_blank" rel="noopener noreferrer"
                   style={{ color: '#bdc3c7', textDecoration: 'none', fontSize: '12px' }}>Help Center</a>
              </li>
              */}
              <li>
                <span style={{ color: '#bdc3c7', fontSize: '12px' }}>(888) 787-3431</span>
              </li>
            </ul>
          </div>

          <div style={{
            flex: isDesktop ? '0 0 auto' : '0 0 100%',
            maxWidth: isDesktop ? '30%' : '100%',
            textAlign: isDesktop ? 'left' : 'center'
          }}>
            <h6 style={{ fontWeight: '600', marginBottom: '10px', fontSize: '14px', color: '#ecf0f1' }}>Get In Touch</h6>
            <div style={{ display: 'flex', gap: '15px', justifyContent: isDesktop ? 'flex-start' : 'center' }}>
              <address style={{ fontSize: '12px', color: '#95a5a6', marginBottom: 0, fontStyle: 'normal', lineHeight: '1.5' }}>
                3 Mill & Main Place, Suite #200<br />
                Maynard, MA 01754-2657
              </address>
              <div>
                <a href="https://www.linkedin.com/company/purehd/" target="_blank" rel="noopener noreferrer"
                   style={{ color: '#4D64C1', fontSize: '18px' }}>
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div style={{
          textAlign: 'center',
          marginTop: '20px',
          paddingTop: '15px',
          borderTop: '1px solid #34495e',
          fontSize: '11px',
          color: '#95a5a6'
        }}>
          &copy; {new Date().getFullYear()} PureHD E-Commerce Platform. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
